import { render, staticRenderFns } from "./OutboundDetails.vue?vue&type=template&id=64a6164a&scoped=true&"
import script from "./OutboundDetails.vue?vue&type=script&lang=js&"
export * from "./OutboundDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6164a",
  null
  
)

export default component.exports